import React from 'react';
import PropTypes from 'prop-types';
import ObjectField from './Object';
import StringField from './String';
import ArrayField from './Array';
import NullField from './Null';
import UnsupportedField from './Unsupported';
import styles from '../../Form.scss';

const COMPONENT_TYPES = {
  array: ArrayField,
  boolean: UnsupportedField,
  integer: UnsupportedField,
  null: NullField,
  number: UnsupportedField,
  object: ObjectField,
  string: StringField,
};

const SchemaField = ({ schema, formData, onChange, uiSchema }) => {
  const { title, type } = schema;
  const description = uiSchema && uiSchema['ui:description'];
  const FieldComponent = COMPONENT_TYPES[type];
  return (
    <div className={styles.fieldSpacing}>
      {title && <h3 className={styles.fieldTitle}>{title}</h3>}
      {description && <div className={styles.fieldDescription}>{description}</div>}
      <FieldComponent
        schema={schema}
        formData={formData}
        uiSchema={uiSchema}
        onChange={onChange}
      />
    </div>
  );
};

SchemaField.propTypes = {
  schema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object,
  formData: PropTypes.any,
  onChange: PropTypes.func.isRequired
};

export default SchemaField;



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Renderer/Fields/SchemaField.js